// extracted by mini-css-extract-plugin
export default {"header":"_3Ram_","wrapper":"_28Lt0","headerWrapper":"_25lw4","headerLink":"_3vk9e","sectionChannels":"_2Fvrf","channels":"Ml2M3","programs":"_2CE9U","desktop":"_3wB9v"};